import { parseFilename } from './files';
import axios from 'axios';
import { RENTAL_CONVERTER_BASE_URL } from '../constants';

export { downloadBlob } from './files';

export interface ReconciliationTotals {
  total_income: number;
  sales_net: number;
  sales_vat: number;
  sales_gross: number;
  landlord_expenses: number;
  payment_due: number;
}

export interface ReconciliationScriptTotals {
  rental_receipts_total: number;
  sales_net_total: number;
  sales_vat_total: number;
  sales_gross_total: number;
  landlord_expense_sheet_total_abs: number;
  purchase_gross_total: number;
}

export interface ReconciliationChecks {
  income_vs_receipts: number;
  sales_net: number;
  sales_vat: number;
  sales_gross: number;
  purchase_expected_minus_script: number;
}

export interface Reconciliation {
  is_aligned: boolean;
  tolerance: number;
  actual_totals: ReconciliationTotals;
  script_totals: ReconciliationScriptTotals;
  checks: ReconciliationChecks;
}

export interface ConvertResult {
  blob: Blob;
  filename: string;
  reconciliation: Reconciliation | null;
}

export async function convertRentalStatement(
  pdfFile: File,
  templateFile: File,
  outputFilename?: string
): Promise<ConvertResult> {
  const formData = new FormData();
  formData.append('pdf_file', pdfFile);
  formData.append('template_file', templateFile);
  if (outputFilename) formData.append('output_filename', outputFilename);

  try {
    const response = await axios.post(
      `${RENTAL_CONVERTER_BASE_URL}/rental-converter/convert`,
      formData,
      { responseType: 'blob' }
    );

    const blob = response.data as Blob;
    const filename = parseFilename(
      response.headers['content-disposition'] || null,
      outputFilename || 'Rental_Statement_Converted.xlsx'
    );
    const reconciliationHeader = response.headers['x-reconciliation'];
    const reconciliation = reconciliationHeader ? (JSON.parse(reconciliationHeader) as Reconciliation) : null;

    return { blob, filename, reconciliation };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorBlob = error.response?.data as Blob | undefined;
      const contentType = String(error.response?.headers?.['content-type'] || '');
      const data =
        errorBlob && contentType.includes('application/json')
          ? JSON.parse(await errorBlob.text())
          : null;
      const message = (data && data.detail) || `Conversion failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}
